import { createDictionaryFromDropdownOptions } from "@/utils/utils.js";

export const BASE_DATE_FORMAT = "hh:mm A, DD MMM YYYY";
export const BASE_TIME_FORMAT = "hh:mm A";
export const MONTH_TIME_FORMAT = "MMMM";
export const DATE_FORMAT_SHORT_WITH_TIME = "hh:mm A - DD MMM, YYYY";
export const BASE_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const InteractionChannelEnum = {
  EMAIL: "email",
  SMS: "sms",
  WHATSAPP: "whatsapp",
  SLACK: "slack",
  META: "meta",
  MSTEAMS: "msteams",
  WORDPRESS: "wordpress",
  WEB: "web",
  GOOGLECHAT: "googlechat",
  WEBFORM: "webform",
};

export const InteractionStatus2Enum = {
  VA_CLOSED: "VA-CLOSED",
  ONGOING: "ONGOING",
  TICKET: "TICKET",
  TICKET_CLOSED: "TICKET-CLOSED",
  TICKET_ON_HOLD: "TICKET-ON-HOLD",
  SOFT_ALERT: "SOFT-ALERT",
  UNKNOWN_USER_TICKET: "TICKET-UNKNOWN-USER",
};

export const DEFAULT_TICKET_STATUS_FILTERS = [
  InteractionStatus2Enum.TICKET,
  // InteractionStatus2Enum.TICKET_ON_HOLD,
];

// Corresponds to "All Tickets" tab on page 1 with default status filters.
export const DEFAULT_INBOX_VIEW_FILTERS = {
  has_ticket: "true",
  status: DEFAULT_TICKET_STATUS_FILTERS,
  page: "1",
};

export const InteractionSourceEnum = {
  BOT: "BOT",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  DIRECT_TICKET: "DIRECT_TICKET",
  TICKET_RESPONSE: "TICKET_RESPONSE",
  FOLLOWUP: "FOLLOWUP",
};

export const TicketResponseStatusEnum = {
  LIVE: "LIVE",
  DRAFT: "DRAFT",
};

export const InteractionDepartmentEnum = {
  ALL: "ALL",
  ACCOUNTING: "ACCOUNTING",
  BUSINESS: "BUSINESS",
  DEVELOPMENT: "DEVELOPMENT",
  SUPPORT: "support",
  SALES: "sales",
  IT: "IT",
};

export const InteractionSortOptionEnum = {
  MOST_RECENT: "MOST_RECENT",
  CREATED_TIME_NEWEST_TO_OLDEST: "CREATED_TIME_NEWEST_TO_OLDEST",
  CREATED_TIME_OLDEST_TO_NEWEST: "CREATED_TIME_OLDEST_TO_NEWEST",
};

export const SortOderEnum = {
  ASC: "asc",
  DESC: "desc",
};

export const InteractionPageEnum = {
  ALL_TICKETS: "ALL_TICKETS",
  MY_TICKETS: "MY_TICKETS",
  MY_TEAMS: "MY_TEAMS",
  MY_DEPARTMENTS: "MY_DEPARTMENTS",
  MY_DRAFTS: "MY_DRAFTS",
  ALL_SOFT_ALERTS: "ALL_SOFT_ALERTS",
  MY_SOFT_ALERTS: "MY_SOFT_ALERTS",
  ALL_INTERACTIONS: "ALL_INTERACTIONS",
  VA_INTERACTIONS: "VA_INTERACTIONS",
  UNKNOWN_USER_TICKETS: "UNKNOWN_USER_TICKETS",
};

export const interactionStatusLabels = Object.freeze({
  [InteractionStatus2Enum.ONGOING]: "AI Ongoing",
  [InteractionStatus2Enum.VA_CLOSED]: "AI Closed",
  [InteractionStatus2Enum.TICKET_CLOSED]: "Closed Ticket",
  [InteractionStatus2Enum.TICKET_ON_HOLD]: "On Hold Ticket",
  [InteractionStatus2Enum.TICKET]: "Open Ticket",
  [InteractionStatus2Enum.SOFT_ALERT]: "Soft Alert",
  [InteractionStatus2Enum.TICKET_UNKNOWN_USER]: "Unknown User Ticket",
});

export const statusBadgeConfig = {
  [InteractionPageEnum.ALL_TICKETS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_TICKETS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_TEAMS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_DEPARTMENTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      count: "9", // TODO hadrcode
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.ALL_SOFT_ALERTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
  ],
  [InteractionPageEnum.MY_SOFT_ALERTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
  ],
  [InteractionPageEnum.ALL_INTERACTIONS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
      value: InteractionStatus2Enum.ONGOING,
      theme: "green", // TODO SCRUM1-1611 was gray, set green
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
      value: InteractionStatus2Enum.VA_CLOSED,
      theme: "green",
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.VA_INTERACTIONS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
      value: InteractionStatus2Enum.ONGOING,
      theme: "green", // TODO SCRUM1-1611 was gray, set green
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
      value: InteractionStatus2Enum.VA_CLOSED,
      theme: "green",
    },
  ],
};

export const InteractionReplyMode2Enum = Object.freeze({
  REPLY_ALL: "Reply All",
  REPLY: "Reply",
  FORWARD: "Forward",
});

export const replyOptions = [
  {
    text: InteractionReplyMode2Enum.REPLY_ALL,
    value: InteractionReplyMode2Enum.REPLY_ALL,
  },
  {
    text: InteractionReplyMode2Enum.REPLY,
    value: InteractionReplyMode2Enum.REPLY,
  },
  {
    text: InteractionReplyMode2Enum.FORWARD,
    value: InteractionReplyMode2Enum.FORWARD,
  },
];

export const RecipientTypeEnum = Object.freeze({
  TO: "to",
  CC: "cc",
  BCC: "bcc",
});

export const interactionStatusDropDownOptions = Object.freeze({
  [InteractionStatus2Enum.TICKET_ON_HOLD]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
    value: InteractionStatus2Enum.TICKET_ON_HOLD,
  },
  [InteractionStatus2Enum.ONGOING]: {
    text: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
    value: InteractionStatus2Enum.ONGOING,
  },
  [InteractionStatus2Enum.SOFT_ALERT]: {
    text: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
    value: InteractionStatus2Enum.SOFT_ALERT,
  },
  [InteractionStatus2Enum.TICKET]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET],
    value: InteractionStatus2Enum.TICKET,
  },
  [InteractionStatus2Enum.TICKET_CLOSED]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
    value: InteractionStatus2Enum.TICKET_CLOSED,
  },
  [InteractionStatus2Enum.VA_CLOSED]: {
    text: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
    value: InteractionStatus2Enum.VA_CLOSED,
  },
});

const interactionStatusDropDownOptionsConfigForAllPagesUnderTickets = {
  [InteractionStatus2Enum.TICKET]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  [InteractionStatus2Enum.TICKET_ON_HOLD]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
  [InteractionStatus2Enum.TICKET_CLOSED]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
};

// This is now the source truth of defining what any given Status can switch to
export const statusToOptionsMapping = {
  [InteractionStatus2Enum.ONGOING]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
  },
  [InteractionStatus2Enum.VA_CLOSED]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.SOFT_ALERT]: {
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.TICKET]: {
    [InteractionStatus2Enum.TICKET_ON_HOLD]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
  [InteractionStatus2Enum.TICKET_CLOSED]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.TICKET_ON_HOLD]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
};

const interactionStatusDropDownOptionsConfigForAllSoftAllertPages = {
  [InteractionStatus2Enum.SOFT_ALERT]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.SOFT_ALERT],
  [InteractionStatus2Enum.VA_CLOSED]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
  [InteractionStatus2Enum.TICKET]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
};

export const interactionStatusDropDownOptionsConfig = {
  [InteractionPageEnum.ALL_TICKETS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_TICKETS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_TEAMS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_DEPARTMENTS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_DRAFTS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.ALL_SOFT_ALERTS]:
    interactionStatusDropDownOptionsConfigForAllSoftAllertPages,
  [InteractionPageEnum.MY_SOFT_ALERTS]:
    interactionStatusDropDownOptionsConfigForAllSoftAllertPages,
  [InteractionPageEnum.ALL_INTERACTIONS]: {
    [InteractionStatus2Enum.ONGOING]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.ONGOING],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.TICKET_ON_HOLD]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
  [InteractionPageEnum.VA_INTERACTIONS]: {
    [InteractionStatus2Enum.ONGOING]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.ONGOING],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
};

export const interactionStatusOptions = Object.freeze([
  {
    text: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
    value: InteractionStatus2Enum.ONGOING,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
    value: InteractionStatus2Enum.SOFT_ALERT,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET],
    value: InteractionStatus2Enum.TICKET,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
    value: InteractionStatus2Enum.TICKET_CLOSED,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
    value: InteractionStatus2Enum.VA_CLOSED,
  },
]);

export const departmentDropdownOptions = [
  {
    text: "All",
    value: InteractionDepartmentEnum.ALL,
  },
  {
    text: "Accounting",
    value: InteractionDepartmentEnum.ACCOUNTING,
  },
  {
    text: "Business",
    value: InteractionDepartmentEnum.BUSINESS,
  },
  {
    text: "Development",
    value: InteractionDepartmentEnum.DEVELOPMENT,
  },
  {
    text: "Sales",
    value: InteractionDepartmentEnum.SALES,
  },
  {
    text: "IT",
    value: InteractionDepartmentEnum.IT,
  },
];

export const interactionStatusesDictionary =
  createDictionaryFromDropdownOptions(interactionStatusOptions);

export const departmentsDictionary = createDictionaryFromDropdownOptions(
  departmentDropdownOptions
);

// Status enum for main gaps, matching PV2 backend.
// Whether recommendation has been seen is user-dependent and hence not included in backend state.
// Manual resolved should be considered ignored because endgoal is that system can
// answer, not that you put in the data already.
// Mapping of enum to clearer names done in component, esp if we want to change wording.
export const ContentGapStatusEnum = Object.freeze({
  ACTIONABLE: "ACTIONABLE",  // Content gap that needs attention, default state
  ASSIGNED: "ASSIGNED",  // Content gap that has been assigned to department for resolution
  IGNORED: "IGNORED",  // Content gap that has been marked as ignored by user
  RESOLVED: "RESOLVED",  // Content gap that has been resolved
});
